export default RAILS_ASSET_URL("/gallery-image-07.webp")
